import { Spin } from 'antd';
import DraftMedicinesTable from 'components/DraftMedicinesRequest';
import { useSelector } from 'react-redux';
import { checkPermission } from 'utils/utils';

export const DraftMedicinesRequest = () => {
	const isProfileLoading = useSelector(
		(state: any) => state?.userProfile?.isLoading,
	);
	const selectedCompanyPermission = useSelector(
		(state: any) => state?.userProfile?.data?.permissions,
	);
	const canViewDraftMedicinesRequest = checkPermission(selectedCompanyPermission, {
		permissionName: 'DraftMedicinesRequest',
		permission: ['view', 'viewAll'],
	});

	if (isProfileLoading) {
		return (
			<div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
				<Spin size="large" />
			</div>
		);
	}

	return <div>{canViewDraftMedicinesRequest && <DraftMedicinesTable />}</div>;
};
